import React from 'react'
import css from './RecipesImagery.module.css'

type RecipesImageryProps = {
  items: { alt: string, src: string }[]
}

const RecipesImagery = ({ items }: RecipesImageryProps) => (
  <ul className={css.list}>
    {
      items.map((image) => (
        <li className={css.listItem} key={image.src}>
          <div className={css.listItemContent}>
            {
              image
              && <img src={image.src} alt={image.alt} className={css.image} />
            }
          </div>
        </li>
      ))
    }
  </ul>
)

export { RecipesImagery }
